import { SSOClient } from "@getgreenline/sso";

function createSsoClient(): SSOClient | null {
  const kcBaseUrl = import.meta.env.VITE_KC_BASE_URL;
  const discoveryRealm = import.meta.env.VITE_KC_DISCOVERY_REALM;

  if (!kcBaseUrl || !discoveryRealm) return null;

  return new SSOClient({
    kcBaseUrl,
    discoveryRealm,
    callbackPath: "/sso/callback",
    postLogoutPath: "/sso/logged-out",
  });
}

export const ssoClient = createSsoClient();
export const ssoEnabled = ssoClient !== null;
